<template>
    <ValidationObserver ref="observer" class="needs-validation form-custom-format">
        <XWindow
            ref="window"
            :title="windowTitle"
            windowClass="height-auto bts-window"
            scrollClass="collection height-auto"
            :height="height"
            :width="width"
            :minHeight="500"
            :maxHeight="maxHeight"
            :group="5"
            :isMaximized="true"
            formStatus="update"
            @dialog-state="dialogState"
        >
            <template #left-button>
               
                <mdb-btn v-if="loading" color="elegant" size="sm" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" /> Loading...
                </mdb-btn>

                <template v-else-if="recordLoaded">
                    <mdb-btn
                        v-if="recordLoaded && !loading && !readOnly"
                        color="elegant"
                        size="sm"
                        :disabled="saving || (form.status === 'open' && availabilityLoading)"
                        @click.native="save"
                        >
                            Save
                    </mdb-btn>

                    <mdb-btn
                        v-for="action in availableActions"
                        :key="action.key"
                        color="elegant"
                        size="sm"
                        class="mr-1"
                        :disabled="saving || (action.key === 'release' && !hasOpenAllocation)"
                        @click.native="handleHeaderAction(action)"
                    >
                        {{ action.label }}
                    </mdb-btn>
                </template>
            </template>

           <!--  <template #right-button>
                
            </template> -->

            <mdb-tabs
                class="table-tabs bts-form-tabs mb-0 form mt-1"
                :active="active"
                default
                :links="tabs"
                @activeTab="getActiveTabIndex"
            >
                <template slot="sales-invoice-slot">
                    <div class="p-3">
                        <div v-if="salesTransaction" class="border rounded p-3 mb-3 bg-light">
                            <h6>Sales Details</h6>
                            <div class="row small">
                                <div class="col-md-4 mb-2"><strong>Customer:</strong> {{ customerName }}</div>
                                <div class="col-md-4 mb-2"><strong>Customer Mobile:</strong> {{ salesTransaction.customer_mobile || (salesInvoice && salesInvoice.customer_mobile) || '-' }}</div>
                                <div class="col-md-4 mb-2"><strong>Transaction Series:</strong> {{ transactionSeries }}</div>
                                <div class="col-md-4 mb-2"><strong>Transaction Date:</strong> {{ salesTransaction.date || '-' }}</div>
                                <div class="col-md-4 mb-2"><strong>Sold By:</strong> {{ salesTransaction.sold_by || '-' }}</div>
                                <div class="col-md-4 mb-2"><strong>Partner:</strong> {{ partnerDisplay }}</div>
                                <div class="col-md-4 mb-2"><strong>Order Status:</strong> {{ statusLabel(salesTransaction.status) }}</div>
                                <div class="col-md-4 mb-2"><strong>Job Order Requested Date:</strong> {{ requestedCompletionDate }}</div>
                            </div>
                        </div>
                        <div v-else class="text-muted border rounded p-3 mb-3">
                            Source transaction details are unavailable.
                        </div>

                        <div v-if="salesInvoice" class="border rounded p-3 mb-3">
                            <h6>Sales Invoice</h6>
                            <div class="row small">
                                <div class="col-md-4 mb-2"><strong>Invoice Series:</strong> {{ salesInvoice.series || '-' }}</div>
                                <div class="col-md-4 mb-2"><strong>Invoice Date:</strong> {{ salesInvoice.date || '-' }}</div>
                                <div class="col-md-4 mb-2"><strong>Invoice Status:</strong> {{ statusLabel(salesInvoice.status) }}</div>
                                <div class="col-md-4 mb-2"><strong>Total:</strong> {{ salesInvoice.total || '-' }}</div>
                                <div class="col-md-4 mb-2"><strong>Address:</strong> {{ salesInvoice.address || '-' }}</div>
                                <div class="col-md-6 mb-2"><strong>Instructions:</strong> {{ salesInvoice.instruction || '-' }}</div>
                                <div class="col-md-6 mb-2"><strong>Other Details:</strong> {{ salesInvoice.other_details || '-' }}</div>
                            </div>
                        </div>
                        <div v-else-if="salesTransaction" class="text-muted border rounded p-3">
                            No Sales Invoice is linked to this transaction yet.
                        </div>

                        <div v-if="salesTransaction" class="mt-3">
                            <h6>Sales Invoice Items</h6>
                            <el-table :data="salesTransaction.items || []" border stripe empty-text="No sales items found." class="custom-element-table" style="width: 100%">
                                <el-table-column type="index" width="50" label="#" align="center" />
                                <el-table-column label="Photo" width="90" align="center">
                                    <template slot-scope="scope">
                                        <img
                                            :src="scope.row.photo || defaultItemPhoto"
                                            alt="Item photo"
                                            style="width: 75px; height: 75px; object-fit: contain"
                                            @error="onPhotoError"
                                        />
                                    </template>
                                </el-table-column>
                                <el-table-column prop="code" label="Code" width="160" />
                                <el-table-column prop="description" label="Item Name" min-width="280" />
                                <el-table-column prop="quantity" label="Qty" width="100" align="right" />
                                <el-table-column prop="price" label="Unit Price" width="130" align="right" />
                                <el-table-column prop="amount" label="Amount" width="140" align="right" />
                            </el-table>
                        </div>
                    </div>
                </template>

                <template slot="job-order-slot">
                    <div class="window-inner-container mt-1">
                        <mdb-row class="tab-row">
                            <mdb-col xl="3" md="6" class="tab-col">
                                <ThatsDatePicker label="Expected Completion Date" labelClass="col-md-5" fieldClass="col-md-7 pl-0" vid="committed_completion_date" name="committed_completion_date" v-model="form.committed_completion_date" :validated="validated" :rules="releaseAttempted && form.status === 'open' ? 'required' : ''" size="sm" :disabled="formLocked" />
                                <ThatsMultiSelect label="Person In Charge" labelClass="col-md-5" fieldClass="col-md-7 pl-0" vid="person_in_charge_id" name="person_in_charge_id" v-model="form.person_in_charge_id" :options="employees" :multiple="false" :reduce="option => option.value || option.id" :reduceLabel="'label'" :validated="validated" :rules="releaseAttempted && form.status === 'open' ? 'required' : ''" size="sm" :disabled="formLocked" />
                                <ThatsMultiSelect label="Priority" labelClass="col-md-5" fieldClass="col-md-7 pl-0" vid="priority" name="priority" v-model="form.priority" :options="priorities" :multiple="false" :reduce="option => option.value" :reduceLabel="'label'" :validated="validated" :rules="'required'" size="sm" :disabled="formLocked" />
                                <!-- <ThatsInput label="Subject" labelClass="col-md-5" fieldClass="col-md-7 pl-0" vid="subject" name="subject" v-model="form.subject" :validated="validated" :rules="''" size="sm" :readOnly="formLocked" /> -->
                            </mdb-col>
                            <mdb-col xl="3" md="6" class="tab-col">
                                <ThatsTextarea label="Description / Instructions" labelClass="col-md-4" fieldClass="col-md-8 pl-0" vid="description" name="description" v-model="form.description" :validated="validated" :rules="''" size="sm" :disabled="formLocked" />
                                <ThatsTextarea label="Remarks" labelClass="col-md-4" fieldClass="col-md-8 pl-0" vid="remarks" name="remarks" v-model="form.remarks" :validated="validated" :rules="''" size="sm" :disabled="formLocked" />
                                <ThatsTextarea v-if="requiresDateReason" label="Reason for Date Change" labelClass="col-md-4" fieldClass="col-md-8 pl-0" vid="reason" name="reason" v-model="dateChangeReason" :validated="validated" :rules="'required'" size="sm" :disabled="formLocked" />
                            </mdb-col>
                            <mdb-col xl="3" md="6" class="tab-col"></mdb-col>
                            <mdb-col xl="3" md="6" class="tab-col">
                                <ThatsInput label="Job Order Series" labelClass="col-md-5" fieldClass="col-md-7 pl-0" vid="series" name="series" :value="form.series || '-'" :validated="validated" :rules="''" size="sm" :readOnly="true" />
                                <ThatsInput label="Document Date" labelClass="col-md-5" fieldClass="col-md-7 pl-0" vid="document_date" name="document_date" :value="form.document_date || '-'" :validated="validated" :rules="''" size="sm" :readOnly="true" />
                                <ThatsInput label="Status" labelClass="col-md-5" fieldClass="col-md-7 pl-0" vid="status" name="status" :value="statusLabel(form.status)" :validated="validated" :rules="''" size="sm" :readOnly="true" />
                            </mdb-col>
                        </mdb-row>
                       <!--  <div v-if="form.items && form.items.length" class="border rounded p-2 mb-2 small bg-light">
                            Assigned: <strong>{{ quantityLabel(progress.assigned) }}</strong>
                            <span class="mx-2">Completed: <strong>{{ quantityLabel(progress.completed) }}</strong></span>
                            <span class="mx-2">Cancelled: <strong>{{ quantityLabel(progress.cancelled) }}</strong></span>
                            <span class="mx-2">Remaining: <strong>{{ quantityLabel(progress.remaining) }}</strong></span>
                        </div> -->

                        <div v-if="form.status === 'open'" class="mb-3">

                        <mdb-row class="tab-row">
                            <mdb-col xl="12" md="12" class="tab-col">

                            <div class="d-flex align-items-center mb-2">
                               
                                <span v-if="availabilityLoading" class="small text-muted ml-2"><span class="spinner-border spinner-border-sm mr-1" /> Loading availability...</span>
                            </div>
                            <el-table :data="allocationRows" border size="small" empty-text="No eligible source quantities available." class="input-table mt-2 custom-element-table">
                                <el-table-column prop="code" label="Item Code" width="200" />
                                <el-table-column label="Photo" width="82" align="center">
                                    <template slot-scope="scope">
                                        <img
                                            :src="scope.row.photo || defaultItemPhoto"
                                            alt="Item photo"
                                            style="width: 55px; height: 55px; object-fit: contain"
                                            @error="onPhotoError"
                                        />
                                    </template>
                                </el-table-column>
                                <el-table-column prop="description" label="Item" min-width="200" />
                                <el-table-column prop="source_quantity" label="Invoice Qty" width="125" align="right" />
                                <el-table-column prop="allocated_quantity" label="Allocated to Other Job Orders" width="280" align="right" />
                                <el-table-column prop="available_quantity" label="Max Allocatable Qty" width="170" align="right" />
                                <el-table-column label="Job Order Qty" width="155" align="center">
                                    <template slot-scope="scope">
                                        <el-input-number v-model="scope.row.allocate_quantity" :min="0" :max="Number(scope.row.available_quantity)" :precision="4" :step="1" :disabled="availabilityLoading || saving || Number(scope.row.available_quantity) <= 0" size="mini" @change="clearAllocationValidation(scope.row)" />
                                        <div v-if="allocationErrors[String(scope.row.transaction_item_id)]" class="text-danger small text-left">
                                            {{ allocationErrors[String(scope.row.transaction_item_id)] }}
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div v-if="allocationErrorMessage" class="text-danger small mt-2" role="alert">
                                {{ allocationErrorMessage }}
                            </div>
                            </mdb-col>
                        </mdb-row>
                        </div>

                        <mdb-row class="tab-row"  v-if="form.status !== 'open'">
                            <mdb-col xl="12" md="12" class="tab-col">

                        <div v-if="canUpdateItems && selectedItems.length" class="d-flex align-items-center mb-2">
                            <span class="small text-muted mr-2">{{ selectedItems.length }} item(s) selected</span>
                            <mdb-btn color="elegant" size="sm" class="mr-1" :disabled="saving || !canBulkStart" @click.native="startSelectedItems">
                                Start Selected
                            </mdb-btn>
                            <mdb-btn color="elegant" size="sm" class="mr-1" :disabled="saving || !canBulkHold" @click.native="holdSelectedItems">
                                Hold Selected
                            </mdb-btn>
                            <mdb-btn color="elegant" size="sm" class="mr-1" :disabled="saving || !canBulkCancel" @click.native="openBulkCancelDialog">
                                Cancel Selected
                            </mdb-btn>
                            <mdb-btn color="elegant" size="sm" :disabled="saving" @click.native="clearBulkSelection">
                                Clear Selection
                            </mdb-btn>
                        </div>

                        <el-table
                            ref="jobOrderItemsTable"
                            :data="form.items || []"
                            border
                            stripe
                            :row-key="row => row.id"
                            class="input-table mt-2 custom-element-table"
                            style="width: 100%"
                            @selection-change="handleItemSelectionChange"
                        >
                            <el-table-column type="selection" width="45" align="center" :selectable="canSelectItemForBulkAction" />
                            <el-table-column type="index" width="50" label="#" align="center" />
                            <el-table-column prop="code" label="Item Code" width="150" />
                            <el-table-column label="Image" width="90" align="center">
                                <template slot-scope="scope">
                                    <img
                                        :src="scope.row.photo || defaultItemPhoto"
                                        alt="Item photo"
                                        style="width: 60px; height: 60px; object-fit: contain"
                                        @error="onPhotoError"
                                    />
                                </template>
                            </el-table-column>
                            <el-table-column prop="description" label="Item Name" width="350" />
                            <el-table-column prop="quantity" label="Allocated Qty" width="115" align="right" />
                            <el-table-column prop="started_quantity" label="Started Qty" width="105" align="right" />
                            <el-table-column label="Start Production" width="175" align="right">
                                <template slot-scope="scope">
                                    <el-input-number
                                        :value="bulkStartQuantities[String(scope.row.id)]"
                                        :min="0"
                                        :max="startable(scope.row)"
                                        :precision="4"
                                        :step="1"
                                        size="mini"
                                        :disabled="!isItemSelected(scope.row) || saving || startable(scope.row) <= 0"
                                        @input="setBulkStartQuantity(scope.row, $event)"
                                    />
                                    <div class="small text-muted">Available: {{ quantityLabel(startable(scope.row)) }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="completed_quantity" label="Completed Qty" width="115" align="right" />
                            <el-table-column prop="cancelled_quantity" label="Cancelled Qty" width="115" align="right" />
                            <el-table-column label="Remaining Qty" width="115" align="right">
                                <template slot-scope="scope">{{ quantityLabel(remaining(scope.row)) }}</template>
                            </el-table-column>
                            <el-table-column prop="unit" label="Unit" width="90" />
                            <el-table-column label="Status" width="120">
                                <template slot-scope="scope">
                                    <mdb-badge class="custom-badge z-depth-0" pill :color="itemStatusColor(scope.row.status)">
                                        {{ statusLabel(scope.row.status) }}
                                    </mdb-badge>
                                </template>
                            </el-table-column>
                            <el-table-column label="Actions" width="140" fixed="right">
                                <template slot-scope="scope">
                                    <el-dropdown v-if="itemActions(scope.row).length" trigger="click" @command="handleItemAction($event, scope.row)">
                                        <el-button size="mini" :disabled="saving || formLocked">
                                            Actions<i class="el-icon-arrow-down el-icon--right"></i>
                                        </el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item v-for="action in itemActions(scope.row)" :key="`${scope.row.id}-${action.key}`" :command="action.key">
                                                {{ action.label }}
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                        </el-table>
                        </mdb-col>
                        </mdb-row>
                    </div>
                </template>

                <template slot="history-slot">
                    <div class="p-3">
                        <h6>Status History</h6>
                        <el-timeline v-if="(form.status_histories || []).length" class="job-order-activity-timeline">
                            <el-timeline-item
                                v-for="history in form.status_histories"
                                :key="`status-${history.id}`"
                                :timestamp="history.created_at"
                                placement="top"
                                type="primary"
                            >
                                <el-card shadow="never" class="job-order-activity-card">
                                    <div class="d-flex align-items-center flex-wrap mb-1">
                                        <el-tag size="mini" effect="plain" type="info">Status Change</el-tag>
                                        <strong class="ml-2">{{ statusLabel(history.from_status) }} → {{ statusLabel(history.to_status) }}</strong>
                                    </div>
                                    <div v-if="history.changed_by" class="small text-muted">
                                        <i class="el-icon-user mr-1" />{{ history.changed_by.name }}
                                    </div>
                                    <div v-if="history.remarks" class="job-order-activity-reason small mt-2">
                                        <strong>Reason:</strong> {{ history.remarks }}
                                    </div>
                                </el-card>
                            </el-timeline-item>
                        </el-timeline>
                        <div class="small text-muted mb-4" v-else>No status history.</div>

                        <h6>Committed Completion Date History</h6>
                        <el-timeline v-if="(form.completion_date_histories || []).length" class="job-order-activity-timeline">
                            <el-timeline-item
                                v-for="history in form.completion_date_histories"
                                :key="`date-${history.id}`"
                                :timestamp="history.created_at"
                                placement="top"
                                type="warning"
                            >
                                <el-card shadow="never" class="job-order-activity-card">
                                    <div class="d-flex align-items-center flex-wrap mb-1">
                                        <el-tag size="mini" effect="plain" type="warning">Date Change</el-tag>
                                        <strong class="ml-2">{{ history.previous_date || '-' }} → {{ history.new_date || '-' }}</strong>
                                    </div>
                                    <div v-if="history.changed_by" class="small text-muted">
                                        <i class="el-icon-user mr-1" />{{ history.changed_by.name }}
                                    </div>
                                    <div v-if="history.reason" class="job-order-activity-reason small mt-2">
                                        <strong>Reason:</strong> {{ history.reason }}
                                    </div>
                                </el-card>
                            </el-timeline-item>
                        </el-timeline>
                        <div class="small text-muted" v-else>No committed date changes.</div>

                        <h6 class="mt-4">Operational Activity</h6>
                        <div v-if="activityLoading" class="small text-muted"><span class="spinner-border spinner-border-sm mr-1" /> Loading activity...</div>
                        <el-timeline v-else-if="activityHistory.length" class="job-order-activity-timeline">
                            <el-timeline-item
                                v-for="activity in activityHistory"
                                :key="`activity-${activity.id}`"
                                :timestamp="activity.date || activity.created_at"
                                placement="top"
                                type="primary"
                            >
                                <el-card shadow="never" class="job-order-activity-card">
                                    <div class="d-flex align-items-center justify-content-between flex-wrap mb-1">
                                        <strong>{{ activity.message || statusLabel(activity.action) }}</strong>
                                        <el-tag
                                            v-if="activity.action"
                                            size="mini"
                                            effect="plain"
                                            :type="activity.action === 'cancel' || activity.action === 'cancel_quantity' ? 'danger' : (activity.action === 'complete' || activity.action === 'close' ? 'success' : (activity.action === 'hold' ? 'warning' : 'info'))"
                                        >
                                            {{ statusLabel(activity.action) }}
                                        </el-tag>
                                    </div>

                                    <div v-if="activity.user || activity.actor" class="small text-muted mb-2">
                                        <i class="el-icon-user mr-1" />{{ activity.user || activity.actor }}
                                    </div>

                                    <div v-if="activity.attr && (activity.attr.item_code || activity.attr.item_status)" class="small mb-2">
                                        <span v-if="activity.attr.item_code"><strong>Item:</strong> {{ activity.attr.item_code }}</span>
                                        <span v-if="activity.attr.item_status" class="ml-3"><strong>Status:</strong> {{ statusLabel(activity.attr.item_status) }}</span>
                                    </div>

                                    <div v-if="activity.attr && activity.attr.reason" class="job-order-activity-reason small mb-2">
                                        <strong>Reason:</strong> {{ activity.attr.reason }}
                                    </div>

                                    <div v-if="activity.attr && activity.attr.quantity != null" class="small text-muted">
                                        <strong>Quantity:</strong> {{ quantityLabel(activity.attr.quantity) }}
                                    </div>
                                    <div v-if="activity.attr && activity.attr.previous_started_quantity != null" class="small text-muted">
                                        Started quantity: {{ quantityLabel(activity.attr.previous_started_quantity) }} → {{ quantityLabel(activity.attr.started_quantity) }}
                                    </div>
                                    <div v-if="activity.attr && activity.attr.previous_completed_quantity != null" class="small text-muted">
                                        Completed quantity: {{ quantityLabel(activity.attr.previous_completed_quantity) }} → {{ quantityLabel(activity.attr.completed_quantity) }}
                                    </div>
                                    <div v-if="activity.attr && activity.attr.previous_cancelled_quantity != null" class="small text-muted">
                                        Cancelled quantity: {{ quantityLabel(activity.attr.previous_cancelled_quantity) }} → {{ quantityLabel(activity.attr.cancelled_quantity) }}
                                    </div>
                                </el-card>
                            </el-timeline-item>
                        </el-timeline>
                        <div v-else class="small text-muted">No operational activity.</div>
                    </div>
                </template>
            </mdb-tabs>
        </XWindow>

        <el-dialog title="Cancel Selected Item Quantities" :visible.sync="bulkCancelDialogVisible" width="760px" :close-on-click-modal="false" append-to-body>
            <div class="small text-muted mb-2">Enter the quantity to cancel for each selected item. Allocated quantities remain unchanged.</div>
            <el-table :data="bulkCancelItems" border size="small" class="custom-element-table" style="width: 100%">
                <el-table-column prop="code" label="Item Code" width="150" />
                <el-table-column prop="description" label="Item" min-width="220" />
                <el-table-column label="Remaining Qty" width="130" align="right">
                    <template slot-scope="scope">{{ quantityLabel(scope.row.remaining_quantity) }}</template>
                </el-table-column>
                <el-table-column label="Cancel Qty" width="180" align="right">
                    <template slot-scope="scope">
                        <el-input-number v-model="scope.row.quantity_to_cancel" :min="0" :max="scope.row.remaining_quantity" :precision="4" :step="1" size="mini" />
                    </template>
                </el-table-column>
            </el-table>
            <el-form-item label="Reason" class="mt-3" :error="bulkActionReason.trim() ? '' : 'A cancellation reason is required.'">
                <el-input v-model="bulkActionReason" type="textarea" :rows="3" maxlength="1000" show-word-limit />
            </el-form-item>
            <span slot="footer">
                <el-button @click="bulkCancelDialogVisible = false">Back</el-button>
                <el-button type="primary" :loading="saving" :disabled="saving || !canSubmitBulkCancel" @click="submitBulkCancel">Cancel Selected</el-button>
            </span>
        </el-dialog>
    </ValidationObserver>
</template>

<script>
import { mdbBadge, mdbBtn, mdbTabs, mdbRow, mdbCol } from 'mdbvue'
import { ValidationObserver } from 'vee-validate'
import { mapActions, mapGetters } from 'vuex'
import { MessageBox } from 'element-ui'
import { ApiHttpService } from '../../services'
import { ThatsDatePicker, ThatsInput, ThatsTextarea, ThatsMultiSelect } from '../../components/thats/Thats'
import XWindow from '../../components/thats/XWindow.vue'

const emptyJobOrderForm = () => ({
    id: null,
    series: '',
    document_date: '',
    status: '',
    priority: 'normal',
    transaction_id: null,
    transaction_series: '',
    transaction: null,
    requested_completion_date: '',
    committed_completion_date: null,
    person_in_charge_id: null,
    subject: '',
    description: '',
    remarks: '',
    items: [],
    status_histories: [],
    completion_date_histories: [],
})

export default {
    components: { mdbBadge, mdbBtn, mdbTabs, mdbRow, mdbCol, ValidationObserver, ThatsDatePicker, ThatsInput, ThatsTextarea, ThatsMultiSelect, XWindow },
    data() {
        return {
            validated: false,
            releaseAttempted: false,
            active: 0,
            form: emptyJobOrderForm(),
            recordLoaded: false,
            originalDate: null,
            dateChangeReason: '',
            allocationRows: [],
            allocationErrors: {},
            allocationErrorMessage: '',
            availabilityLoading: false,
            availabilityRequestToken: 0,
            activityHistory: [],
            activityLoading: false,
            activityRequestToken: 0,
            employees: [],
            partners: [],
            selectedItems: [],
            bulkStartQuantities: {},
            bulkCancelItems: [],
            bulkCancelDialogVisible: false,
            bulkActionReason: '',
            priorities: [
                { label: 'Low', value: 'low' },
                { label: 'Normal', value: 'normal' },
                { label: 'High', value: 'high' },
                { label: 'Urgent', value: 'urgent' },
            ],
            height: 800,
            width: 1300,
            maxHeight: 900,
            defaultItemPhoto: 'https://media.thatsliving.com/assets/default-item-img-small.jpg',
            tabs: [
                { text: 'Details', slot: 'job-order-slot' },
                { text: 'Sales Invoice', slot: 'sales-invoice-slot' },
                { text: 'History', slot: 'history-slot' },
            ],
        }
    },
    created() {
        this.width = window.innerWidth
        this.height = window.innerHeight
        this.maxHeight = window.innerHeight
    },
    computed: {
        ...mapGetters('JobOrderModule', ['record', 'loading', 'saving']),
        readOnly() { return ['completed', 'closed', 'cancelled'].includes(this.form.status) },
        formLocked() { return this.loading || !this.recordLoaded || this.readOnly },
        canUpdateItems() { return ['released', 'in_progress', 'partially_completed'].includes(this.form.status) },
        requiresDateReason() { return !!this.originalDate && this.originalDate !== this.form.committed_completion_date },
        salesTransaction() { return this.form.transaction || null },
        salesInvoice() { return this.salesTransaction && this.salesTransaction.invoice || null },
        customerName() { return this.form.transaction && (this.form.transaction.customer_name || (this.form.transaction.customer && this.form.transaction.customer.name)) || '-' },
        transactionSeries() { return this.form.transaction_series || (this.form.transaction && this.form.transaction.series) || this.form.transaction_id || '-' },
        requestedCompletionDate() { return this.form.requested_completion_date || (this.form.transaction && this.form.transaction.requested_completion_date) || '-' },
        partnerDisplay() {
            const selected = this.salesTransaction && this.salesTransaction.partner
            const values = Array.isArray(selected) ? selected : (selected ? [selected] : [])
            const labels = values.map(partner => {
                const id = partner && typeof partner === 'object' ? (partner.id != null ? partner.id : partner.code) : partner
                const option = this.partners.find(row => String(row.id) === String(id))
                return option ? option.name : (partner && typeof partner === 'object' ? (partner.name || partner.label || id) : id)
            }).filter(value => value != null && value !== '')
            return labels.length ? labels.join(', ') : '-'
        },
        windowTitle() { return this.form.series ? `Job Order - ${this.form.series}` : 'Job Order' },
        availableActions() {
            const actions = {
                open: [{ key: 'release', label: 'Release Job Order' }, { key: 'cancel', label: 'Cancel Job Order' }],
                released: [{ key: 'hold', label: 'Hold Job Order' }, { key: 'cancel', label: 'Cancel Job Order' }],
                in_progress: [{ key: 'hold', label: 'Hold Job Order' }, { key: 'cancel', label: 'Cancel Job Order' }],
                partially_completed: [{ key: 'hold', label: 'Hold Job Order' }, { key: 'cancel', label: 'Cancel Job Order' }],
                on_hold: [
                    { key: 'resume-header', label: 'Resume Job Order' },
                    { key: 'cancel', label: 'Cancel Job Order' },
                ],
                completed: [{ key: 'close', label: 'Close Job Order' }],
            }
            return actions[this.form.status] || []
        },
        progress() {
            const items = this.form.items || []
            return items.reduce((totals, item) => {
                totals.assigned += Number(item.quantity || 0)
                totals.completed += Number(item.completed_quantity || 0)
                totals.cancelled += Number(item.cancelled_quantity || 0)
                totals.remaining += this.remaining(item)
                return totals
            }, { assigned: 0, completed: 0, cancelled: 0, remaining: 0 })
        },
        hasOpenAllocation() {
            return this.form.status === 'open'
                && !this.availabilityLoading
                && this.allocationRows.some(item => Number(item.allocate_quantity || 0) > 0)
        },
        canBulkStart() {
            return this.selectedItems.length > 0 && this.selectedItems.every(item => {
                const quantity = this.normalizeQuantity(this.bulkStartQuantities[String(item.id)])
                return ['not_started', 'in_progress'].includes(item.status)
                    && quantity > 0
                    && quantity <= this.startable(item)
            })
        },
        canBulkHold() {
            return this.selectedItems.length > 0 && this.selectedItems.every(item =>
                this.remaining(item) > 0 && !['on_hold', 'completed', 'cancelled'].includes(item.status)
            )
        },
        canBulkCancel() {
            return this.selectedItems.length > 0 && this.selectedItems.every(item =>
                this.remaining(item) > 0 && !['completed', 'cancelled'].includes(item.status)
            )
        },
        canSubmitBulkCancel() {
            return this.bulkCancelItems.length > 0
                && !!String(this.bulkActionReason || '').trim()
                && this.bulkCancelItems.every(item => {
                    const quantity = this.normalizeQuantity(item.quantity_to_cancel)
                    return quantity > 0 && quantity <= item.remaining_quantity
                })
        },
    },
    methods: {
        ...mapActions('JobOrderModule', [
            'getRecord', 'getAvailableItems', 'updateRecord', 'releaseJobOrder',
            'holdJobOrder', 'resumeJobOrder', 'closeJobOrder', 'cancelJobOrder',
            'startJobOrderItem', 'completeJobOrderItem', 'holdJobOrderItem', 'resumeJobOrderItem',
            'cancelJobOrderItemQuantity', 'bulkJobOrderItemsAction',
        ]),
        openDialog(id) {
            this.validated = false
            this.releaseAttempted = false
            this.active = 0
            this.form = emptyJobOrderForm()
            this.recordLoaded = false
            this.originalDate = null
            this.dateChangeReason = ''
            this.allocationRows = []
            this.clearBulkSelection()
            this.activityHistory = []
            this.activityLoading = false
            this.availabilityRequestToken += 1
            this.activityRequestToken += 1
            this.loadEmployees()
            this.loadPartners()
            this.$refs.window.openDialog()
            this.getRecord(id).then(record => {
                this.form = this.hydrateRecord(record)
                this.originalDate = this.form.committed_completion_date || null
                this.recordLoaded = true
                this.loadAllocationRows()
                this.loadActivityHistory()
            }).catch(error => this.notifyError(error))
        },
        closeDialog() {
            this.availabilityRequestToken += 1
            this.activityRequestToken += 1
            this.$refs.window.closeDialog()
            this.dateChangeReason = ''
            this.clearBulkSelection()
        },
        dialogState(isOpen) {
            if (!isOpen) this.dateChangeReason = ''
        },
        getActiveTabIndex(index) { this.active = index },
        loadEmployees() {
            ApiHttpService.getRequest('employees/data', { length: 1000, page: 1, term: '' }).then(response => {
                const rows = response.data.data || response.data || []
                this.employees = rows.map(employee => ({ label: employee.name, value: employee.id || employee.mdbID }))
                this.ensurePersonInChargeOption()
            }).catch(() => {
                this.employees = []
                this.ensurePersonInChargeOption()
            })
        },
        loadPartners() {
            ApiHttpService.getRequest('sales/partner').then(response => {
                const rows = response.data.data || response.data || []
                this.partners = rows.map(partner => ({ id: partner.id, name: partner.name }))
            }).catch(() => { this.partners = [] })
        },
        async save(options) {
            const silent = options && options.silent
            if (!this.recordLoaded || this.loading || this.saving || !this.$refs.observer) return false
            if (this.form.status === 'open' && this.availabilityLoading) return false
            this.validated = true
            const valid = await this.$refs.observer.validate()
            if (!valid) {
                this.active = 0
                return false
            }
            const payload = Object.assign({}, this.form)
            if (this.requiresDateReason) payload.reason = this.dateChangeReason
            if (this.form.status === 'open') {
                payload.items = this.allocationRows
                    .filter(item => Number(item.allocate_quantity || 0) > 0)
                    .map(item => ({ transaction_item_id: item.transaction_item_id, quantity: Number(item.allocate_quantity) }))
            }
            try {
                const record = await this.updateRecord(payload)
                this.refreshRecord(record)
                this.originalDate = this.form.committed_completion_date
                this.dateChangeReason = ''
                if (!silent) this.$ThatsNotify.success({ message: 'Job Order updated successfully' })
                this.$emit('success', record)
                return record
            } catch (error) {
                this.notifyError(error, payload.items)
                return false
            }
        },
        async handleHeaderAction(action) {
            if (this.saving || !this.recordLoaded) return
            if (action.key === 'release') {
                this.releaseAttempted = true
                this.validated = true
                this.active = 0
                await this.$nextTick()
                if (!await this.$refs.observer.validate()) return
                MessageBox.confirm(
                    'Release this Job Order to Production? Source items and allocated quantities will no longer be freely editable.',
                    'Release Job Order',
                    { type: 'warning', confirmButtonText: 'Release', cancelButtonText: 'Keep Open' }
                ).then(async () => {
                    const saved = await this.save({ silent: true })
                    if (!saved) return
                    const record = await this.releaseJobOrder(saved.id)
                    this.refreshAfterAction(record)
                })
                    .catch(error => { if (error !== 'cancel') this.notifyError(error) })
                return
            }
            if (action.key === 'cancel') {
                this.promptReason('Cancellation Reason').then(reason => this.cancelJobOrder({ id: this.form.id, reason }))
                    .then(record => this.refreshAfterAction(record))
                    .catch(error => { if (error !== 'cancel') this.notifyError(error) })
                return
            }
            if (action.key === 'hold') {
                this.promptReason('Reason for Holding the Job Order').then(reason => this.holdJobOrder({ id: this.form.id, reason }))
                    .then(record => this.refreshAfterAction(record))
                    .catch(error => { if (error !== 'cancel') this.notifyError(error) })
                return
            }
            if (action.key === 'close') {
                MessageBox.confirm('Close this completed Job Order?', 'Close Job Order', { type: 'warning' })
                    .then(() => this.closeJobOrder(this.form.id))
                    .then(record => this.refreshAfterAction(record))
                    .catch(error => { if (error !== 'cancel') this.notifyError(error) })
                return
            }
            if (action.key === 'resume-header') {
                this.resumeJobOrder(this.form.id).then(record => this.refreshAfterAction(record)).catch(error => this.notifyError(error))
            }
        },
        promptReason(title) {
            return MessageBox.prompt('This reason will be recorded in Job Order history.', title, {
                inputType: 'textarea',
                inputValidator: value => String(value || '').trim() ? true : 'A reason is required.',
                confirmButtonText: 'Continue',
                cancelButtonText: 'Cancel',
            }).then(result => String(result.value || '').trim())
        },
        promptQuantity(title, maximum, initialValue = maximum, promptMessage = null) {
            maximum = this.normalizeQuantity(maximum)
            const initialQuantity = Math.min(maximum, Math.max(0, this.normalizeQuantity(initialValue)))
            return MessageBox.prompt(promptMessage || `Enter a quantity from 0.0001 to ${this.quantityLabel(maximum)}.`, title, {
                inputType: 'number',
                inputValue: String(initialQuantity),
                inputValidator: value => {
                    const quantity = Number(value)
                    const normalizedQuantity = this.normalizeQuantity(quantity)
                    return Number.isFinite(quantity) && normalizedQuantity > 0 && normalizedQuantity <= maximum
                        ? true
                        : `Enter a positive quantity no greater than ${this.quantityLabel(maximum)}.`
                },
                confirmButtonText: 'Continue',
                cancelButtonText: 'Cancel',
            }).then(result => this.normalizeQuantity(result.value))
        },
        itemActions(item) {
            if (!this.canUpdateItems || this.remaining(item) <= 0) return []
            if (item.status === 'completed' || item.status === 'cancelled') return []
            if (item.status === 'on_hold') {
                return [{ key: 'resume', label: 'Resume' }, { key: 'cancel', label: 'Cancel Remaining' }]
            }
            const actions = []
            if (this.startable(item) > 0) actions.push({ key: 'start', label: 'Start' })
            if (this.completable(item) > 0) actions.push({ key: 'complete', label: 'Complete Qty' })
            actions.push({ key: 'hold', label: 'Hold' })
            actions.push({ key: 'cancel', label: 'Cancel Remaining' })
            return actions
        },
        startable(item) {
            return Math.max(0, this.normalizeQuantity(Number(item.quantity || 0) - Number(item.started_quantity || 0) - Number(item.cancelled_quantity || 0)))
        },
        canSelectItemForBulkAction(item) {
            return this.canUpdateItems
                && this.remaining(item) > 0
                && !['completed', 'cancelled'].includes(item.status)
        },
        isItemSelected(item) {
            return this.selectedItems.some(selected => String(selected.id) === String(item.id))
        },
        handleItemSelectionChange(selection) {
            this.selectedItems = selection
            selection.forEach(item => {
                const key = String(item.id)
                if (this.bulkStartQuantities[key] === undefined) {
                    this.$set(this.bulkStartQuantities, key, Math.min(1, this.startable(item)))
                }
            })
        },
        setBulkStartQuantity(item, value) {
            const quantity = Math.max(0, Math.min(this.startable(item), this.normalizeQuantity(value)))
            this.$set(this.bulkStartQuantities, String(item.id), quantity)
        },
        startSelectedItems() {
            if (this.saving || !this.canBulkStart) return
            MessageBox.confirm(
                `Start production for ${this.selectedItems.length} selected item(s) using the entered quantities?`,
                'Start Selected Items',
                { type: 'warning', confirmButtonText: 'Start', cancelButtonText: 'Cancel' }
            ).then(() => this.submitBulkItemAction({
                action: 'start',
                items: this.selectedItems.map(item => ({
                    id: item.id,
                    quantity_to_start: this.normalizeQuantity(this.bulkStartQuantities[String(item.id)]),
                })),
            })).catch(error => { if (error !== 'cancel') this.notifyBulkActionError(error) })
        },
        holdSelectedItems() {
            if (this.saving || !this.canBulkHold) return
            this.promptReason('Reason for Holding Selected Items').then(reason => this.submitBulkItemAction({
                action: 'hold',
                reason,
                items: this.selectedItems.map(item => ({ id: item.id })),
            })).catch(error => { if (error !== 'cancel') this.notifyBulkActionError(error) })
        },
        openBulkCancelDialog() {
            if (this.saving || !this.canBulkCancel) return
            this.bulkCancelItems = this.selectedItems.map(item => ({
                id: item.id,
                code: item.code,
                description: item.description,
                remaining_quantity: this.remaining(item),
                quantity_to_cancel: this.remaining(item),
            }))
            this.bulkActionReason = ''
            this.bulkCancelDialogVisible = true
        },
        submitBulkCancel() {
            if (this.saving || !this.canSubmitBulkCancel) return
            this.submitBulkItemAction({
                action: 'cancel',
                reason: String(this.bulkActionReason).trim(),
                items: this.bulkCancelItems.map(item => ({
                    id: item.id,
                    quantity_to_cancel: this.normalizeQuantity(item.quantity_to_cancel),
                })),
            }).then(record => {
                if (!record) return
                this.bulkCancelDialogVisible = false
                this.bulkActionReason = ''
            })
                .catch(error => this.notifyBulkActionError(error))
        },
        submitBulkItemAction(payload) {
            if (!this.form.id) return Promise.reject(new Error('Job Order is not loaded.'))
            return this.bulkJobOrderItemsAction(Object.assign({ job_order_id: this.form.id }, payload))
                .then(record => {
                    this.refreshAfterAction(record)
                    return record
                })
        },
        notifyBulkActionError(error) {
            const data = error.response && error.response.data
            const errors = data && data.errors
            const messages = errors
                ? Object.keys(errors).reduce((all, field) => all.concat(Array.isArray(errors[field]) ? errors[field] : [errors[field]]), [])
                : []
            this.$ThatsNotify.error({
                message: messages.length ? messages.join(' ') : (data && data.message ? data.message : (error.message || 'Unable to update selected Job Order items')),
            })
        },
        clearBulkSelection() {
            this.selectedItems = []
            this.bulkStartQuantities = {}
            this.bulkCancelItems = []
            this.bulkCancelDialogVisible = false
            this.bulkActionReason = ''
            this.$nextTick(() => {
                if (this.$refs.jobOrderItemsTable) this.$refs.jobOrderItemsTable.clearSelection()
            })
        },
        completable(item) {
            return Math.max(0, this.normalizeQuantity(Math.min(this.remaining(item), Number(item.started_quantity || 0) - Number(item.completed_quantity || 0))))
        },
        handleItemAction(action, item) {
            if (this.saving || !this.canUpdateItems) return
            const common = { id: item.id, job_order_id: this.form.id }
            if (action === 'start') {
                const availableToStart = this.startable(item)
                const startPrompt = `Item: ${item.description || item.code}. Allocated: ${this.quantityLabel(item.quantity)}; already started: ${this.quantityLabel(item.started_quantity)}; available to start: ${this.quantityLabel(availableToStart)}.`
                this.promptQuantity('Start Production', availableToStart, Math.min(1, availableToStart), startPrompt)
                    .then(quantity => this.startJobOrderItem(Object.assign({}, common, { quantity_to_start: quantity })))
                    .then(record => this.refreshAfterAction(record))
                    .catch(error => { if (error !== 'cancel') this.notifyError(error) })
                return
            }
            if (action === 'complete') {
                this.promptQuantity('Complete Item Quantity', this.completable(item))
                    .then(quantity => this.completeJobOrderItem(Object.assign({}, common, { quantity_to_complete: quantity })))
                    .then(record => this.refreshAfterAction(record))
                    .catch(error => { if (error !== 'cancel') this.notifyError(error) })
                return
            }
            if (action === 'hold') {
                this.promptReason('Reason for Holding Item')
                    .then(reason => this.holdJobOrderItem(Object.assign({}, common, { reason })))
                    .then(record => this.refreshAfterAction(record))
                    .catch(error => { if (error !== 'cancel') this.notifyError(error) })
                return
            }
            if (action === 'resume') {
                this.resumeJobOrderItem(common).then(record => this.refreshAfterAction(record)).catch(error => this.notifyError(error))
                return
            }
            if (action === 'cancel') {
                this.promptQuantity('Cancel Remaining Quantity', this.remaining(item))
                    .then(quantity => this.promptReason('Reason for Cancelling Quantity').then(reason => ({ quantity, reason })))
                    .then(values => this.cancelJobOrderItemQuantity(Object.assign({}, common, {
                        quantity_to_cancel: values.quantity,
                        reason: values.reason,
                    })))
                    .then(record => this.refreshAfterAction(record))
                    .catch(error => { if (error !== 'cancel') this.notifyError(error) })
            }
        },
        refreshRecord(record) {
            this.clearBulkSelection()
            this.form = this.hydrateRecord(record)
            this.recordLoaded = true
            this.loadAllocationRows()
            this.loadActivityHistory()
        },
        hydrateRecord(record) {
            const data = Object.assign(emptyJobOrderForm(), JSON.parse(JSON.stringify(record)))
            if ((data.person_in_charge_id === null || data.person_in_charge_id === undefined)
                && data.person_in_charge && data.person_in_charge.id !== undefined) {
                data.person_in_charge_id = data.person_in_charge.id
            }
            this.form = data
            this.ensurePersonInChargeOption()
            return data
        },
        ensurePersonInChargeOption() {
            const person = this.form.person_in_charge
            if (!person || person.id === null || person.id === undefined) return
            const exists = this.employees.some(employee => String(employee.value) === String(person.id))
            if (!exists) this.employees.push({ label: person.name, value: person.id })
        },
        refreshAfterAction(record) {
            this.refreshRecord(record)
            this.$ThatsNotify.success({ message: 'Job Order updated successfully' })
            this.$emit('success', record)
        },
        loadAllocationRows() {
            const requestToken = ++this.availabilityRequestToken
            this.allocationRows = []
            this.clearAllocationValidation()
            if (this.form.status !== 'open' || !this.form.transaction_id) {
                this.availabilityLoading = false
                return
            }
            this.availabilityLoading = true
            const currentItems = (this.form.items || []).reduce((items, item) => {
                items[String(item.transaction_item_id)] = item
                return items
            }, {})
            this.getAvailableItems({
                transaction_id: this.form.transaction_id,
                exclude_job_order_id: this.form.id,
            }).then(items => {
                if (requestToken !== this.availabilityRequestToken || this.form.status !== 'open') return
                this.allocationRows = items.map(source => {
                    const current = currentItems[String(source.transaction_item_id)]
                    return Object.assign({}, source, {
                        allocate_quantity: current ? Number(current.quantity) : 0,
                    })
                })
            }).catch(error => {
                if (requestToken === this.availabilityRequestToken) this.notifyError(error)
            }).finally(() => {
                if (requestToken === this.availabilityRequestToken) this.availabilityLoading = false
            })
        },
        loadActivityHistory() {
            if (!this.form.id) return
            const requestToken = ++this.activityRequestToken
            this.activityLoading = true
            ApiHttpService.getRequest(`history/job-order/${this.form.id}/`, { length: 100 }).then(response => {
                if (requestToken === this.activityRequestToken) this.activityHistory = response.data.data || []
            }).catch(() => {
                if (requestToken === this.activityRequestToken) this.activityHistory = []
            }).finally(() => {
                if (requestToken === this.activityRequestToken) this.activityLoading = false
            })
        },
        remaining(item) {
            return Math.max(0, this.normalizeQuantity(Number(item.quantity || 0) - Number(item.completed_quantity || 0) - Number(item.cancelled_quantity || 0)))
        },
        normalizeQuantity(value) {
            return Math.round(Number(value || 0) * 10000) / 10000
        },
        quantityLabel(value) {
            const quantity = this.normalizeQuantity(value)
            return String(Number(quantity.toFixed(4)))
        },
        itemStatusColor(status) {
            const colors = {
                not_started: 'secondary',
                in_progress: 'info',
                on_hold: 'warning',
                completed: 'success',
                cancelled: 'danger',
            }
            return colors[status] || 'secondary'
        },
        statusLabel(status) { return String(status || '-').replace(/_/g, ' ').replace(/\b\w/g, letter => letter.toUpperCase()) },
        onPhotoError(event) {
            if (event.target.src !== this.defaultItemPhoto) event.target.src = this.defaultItemPhoto
        },
        notifyError(error, submittedItems) {
            const data = error.response && error.response.data
            if (submittedItems) this.setAllocationValidationErrors(data && data.errors, submittedItems)
            this.$ThatsNotify.error({ message: data && data.message ? data.message : 'Unable to update Job Order' })
            if (data && data.errors && this.$refs.observer) this.$refs.observer.setErrors(data.errors)
        },
        setAllocationValidationErrors(errors, submittedItems) {
            this.clearAllocationValidation()
            if (!errors) return
            const generalErrors = errors.items || []
            this.allocationErrorMessage = Array.isArray(generalErrors) ? generalErrors.join(' ') : String(generalErrors)
            Object.keys(errors).forEach(field => {
                const match = field.match(/^items\.(\d+)(?:\.|$)/)
                if (!match) return
                const item = submittedItems[Number(match[1])]
                if (!item) return
                const messages = errors[field]
                this.$set(
                    this.allocationErrors,
                    String(item.transaction_item_id),
                    Array.isArray(messages) ? messages.join(' ') : String(messages)
                )
            })
        },
        clearAllocationValidation(item) {
            if (item) this.$delete(this.allocationErrors, String(item.transaction_item_id))
            else this.allocationErrors = {}
            this.allocationErrorMessage = ''
        },
    },
}
</script>

<style scoped>
.job-order-activity-timeline {
    padding: 8px 8px 0 4px;
}

.job-order-activity-card {
    border: 1px solid #e4e7ed;
    border-radius: 4px;
}

.job-order-activity-reason {
    padding: 7px 10px;
    background: #fff8e1;
    border-left: 3px solid #e6a23c;
    color: #606266;
}
</style>
